<template>
  <v-layout
    column
    align-center
  >
    <div class="display-2 grey--text main-title">{{ $t('page_not_found') }}</div>
    <div class="body-2 my-3">
      <router-link :to="{ name: home }">
        {{ $t('go_home') }}
      </router-link>
    </div>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'not-found',
  layout: 'common',
  computed: {
    ...mapGetters('auth', [
      'authenticated'
    ]),
    home () {
      return this.authenticated ? 'home' : 'welcome'
    }
  }
}
</script>

<style scoped>
.main-title {
  margin-top: 150px;
}
</style>



// WEBPACK FOOTER //
// src/pages/errors/404.vue